import { useDispatch } from "react-redux";
import clsx from "clsx";
import { removeItem } from "../../features/cart/cartSlice";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../buttons/Button";
import Spinner from "../skeletons/spinnerButton";

function FooterCart({
  isPhone,
  cartItems,
  isCheckedAll,
  setIsAllChecked,
  isChecked,
  totalPrice = 0,
  isChangeFooter,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Sử dụng useRef để lưu isSticky
  const [isSticky, setIsSticky] = useState(false);
  const footerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleClearCart = () => {
    isChecked.forEach((checked, index) => {
      if (checked) {
        dispatch(removeItem(cartItems[index].selectedAttributes.attribute.id));
      }
    });
  };

  const handleBuyNow = async () => {
    let buyItems = [];
    setIsLoading(true);
    try {
      isChecked.forEach((checked, index) => {
        if (checked) {
          buyItems.push(cartItems[index]);
        }
      });
      navigate("/purchase", { state: buyItems });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const footerEl = footerRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(!entry.isIntersecting);
      },
      { threshold: 0.1 },
    );
    if (footerEl) {
      observer.observe(footerEl);
    }
    return () => {
      if (footerEl) {
        observer.unobserve(footerEl);
      }
    };
  }, []);

  return (
    <>
      <div
        className={`fixed md:sticky bottom-0 right-0 w-full h-20 bg-white mt-5 flex items-center justify-between px-2 md:px-2 lg:px-10 
            ${isSticky ? "shadow-[0_-10px_30px_-20px_rgba(0,0,0,0.3)] border-t" : "border-b border-gray-200"}`}
      >
        <div
          className={`flex items-center justify-between md:w-auto gap-2 md:gap-4 lg:gap-10
            ${isPhone ? (isChangeFooter === true ? "w-full" : "") : ""}`}
        >
          {/* Checkbox */}
          <div className="flex items-center justify-center gap-2 md:gap-4 lg:gap-10">
            <input
              type="checkbox"
              className="flex-shrink-0 relative appearance-none w-[18px] h-[18px] border border-[#DBDBDB] rounded-sm 
                        checked:bg-primaryColor checked:border-primaryColor"
              checked={isCheckedAll}
              onChange={(e) => setIsAllChecked(e.target.checked)}
            />
            <div className="whitespace-nowrap text-sm md:text-base">
              Chọn tất cả
            </div>
          </div>
          <div className="flex gap-2 md:gap-4 lg:gap-10">
            <button
              className={`${isPhone ? (isChangeFooter === true && isPhone ? "block" : "hidden") : ""} text-sm md:text-base`}
              onClick={handleClearCart}
            >
              Xóa
            </button>
            <button
              className={`${isPhone ? (isChangeFooter === true && isPhone ? "block" : "hidden") : ""} text-base 
                        text-primaryTextColor md:text-black font-semibold md:font-normal`}
            >
              <span className="md:hidden lg:block">Lưu vào mục yêu thích</span>
              <span className="hidden md:block lg:hidden">Yêu thích</span>
            </button>
          </div>
        </div>
        <div
          className={clsx(
            "items-center justify-end gap-2 md:gap-4 lg:gap-10",
            isChangeFooter === true ? "hidden md:flex" : "flex",
          )}
        >
          <div className="flex flex-col md:flex-shrink-0 md:flex-row items-center md:items-center justify-end md:gap-3">
            <div className="text-sm md:text-base flex flex-col md:flex-row items-center justify-center md:gap-1">
              Tổng cộng
              {isPhone ? (
                <span className="whitespace-nowrap">
                  ({isChecked.filter((item) => item).length} sản phẩm):
                </span>
              ) : (
                <> ({isChecked.filter((item) => item).length} sản phẩm):</>
              )}
            </div>
            <div className="flex justify-start md:justify-center text-base md:text-2xl font-normal text-primaryTextColor">
              <i className="fa-solid fa-dong-sign text-xs md:text-[14px] relative top-0 md:top-[8px] right-[2px]"></i>
              {totalPrice.toLocaleString("vi-VN")}
            </div>
          </div>
          <PrimaryButton
            height="40px"
            width={isPhone ? "120px" : "200px"}
            text={"Mua Hàng"}
            onClick={() => handleBuyNow()}
            className="!flex-shrink-0 !flex-none"
          >
            <div
              className={`absolute top-0 left-0 w-full h-full flex items-center justify-center
              ${isLoading ? "bg-white/50" : "hidden"}`}
            >
              <Spinner
                size={"30px"}
                stroke={"5px"}
                _hidden={isLoading ? "" : "hidden"}
                color={"white"}
              />
            </div>
          </PrimaryButton>
        </div>
      </div>
      <div ref={footerRef} className="w-full h-0 hidden md:block"></div>
    </>
  );
}
export default FooterCart;
